export const SUPPORTED_PRODUCTS = [
  'analyze',
  'engage',
  'publish',
  'appshell',
] /* appshell has been added for testing purposes */
